import { Table } from "@tanstack/react-table";
import { clsx } from "clsx";
import { ReactNode } from "react";

import { Filter } from "./filter";

const styles = {
  toolbarWrapper: "text-ui w-full min-h-[7.8rem] shrink-0",
  toolbar: "flex w-full items-start mx-auto px-[16px] pt-2 pb-[16px]",
  toolbarFilters:
    "flex flex-1 items-start justify-start gap-3 flex-wrap min-w-0",
  toolbarLeftPanel: "flex flex-col gap-2 shrink-0 pr-[16px]",
  filterSeparator: "pl-[16px] border-l-[1px] border-neutral-100",
};

const MAX_ORDER = 1000;

type ToolbarProps<I> = {
  table: Table<I>;
  enableColumnFilters?: boolean;
  leftPanel?: ReactNode;
  loading?: boolean;
  clearRowSelection: () => void;
};

export const Toolbar = <I extends {}>({
  table,
  enableColumnFilters,
  leftPanel,
  loading,
  clearRowSelection,
}: ToolbarProps<I>) => {
  const canFilterColumns = !enableColumnFilters
    ? []
    : table
        .getAllColumns()
        .filter((col) => col.getCanFilter())
        .sort(
          (a, b) =>
            (a.columnDef.meta?.filter?.order || MAX_ORDER) -
            (b.columnDef.meta?.filter?.order || MAX_ORDER),
        );

  const filters = canFilterColumns.map((col) => (
    <Filter
      key={col.id}
      column={col}
      clearRowSelection={clearRowSelection}
      disabled={loading}
    />
  ));

  if (!leftPanel && !filters.length) return null;

  const hiddenLabel = (
    <span className="pointer-events-none select-none invisible" aria-hidden>
      {"\u00a0"}
    </span>
  );

  return (
    <div className={styles.toolbarWrapper}>
      <div className={styles.toolbar}>
        {leftPanel && (
          <div className={styles.toolbarLeftPanel}>
            {hiddenLabel}
            {leftPanel}
          </div>
        )}
        <div
          className={clsx(
            styles.toolbarFilters,
            leftPanel && styles.filterSeparator,
          )}
        >
          {filters?.length ? filters : null}
        </div>
      </div>
    </div>
  );
};
